import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ShippingAccounting } from '../../domain/entities/shipping-accounting.entity';
import { DateRange } from '../../data/adapters/shipping-accounting-filter.adapter';

export interface ShippingAccountingStoreState {
  loading: boolean;
  loadingMore: boolean;
  items: readonly ShippingAccounting[];
  total: number;
  errorMessage: string | null;
  sendingEmail: boolean;
  downloadingCsvFor: string | null;
  dateRange: DateRange;
}

const initialState: ShippingAccountingStoreState = {
  loading: false,
  loadingMore: false,
  items: [],
  total: 0,
  errorMessage: null,
  sendingEmail: false,
  downloadingCsvFor: null,
  dateRange: { start: '', end: '' },
};

@Injectable()
export class ShippingAccountingStore {
  private readonly stateSubject = new BehaviorSubject<ShippingAccountingStoreState>(initialState);
  readonly state$ = this.stateSubject.asObservable();

  setLoading(): void {
    this.patch({ loading: true, loadingMore: false, errorMessage: null });
  }

  setLoadingMore(): void {
    this.patch({ loadingMore: true, errorMessage: null });
  }

  setItems(items: readonly ShippingAccounting[], total: number): void {
    this.patch({ loading: false, loadingMore: false, items, total, errorMessage: null });
  }

  appendItems(items: readonly ShippingAccounting[], total: number): void {
    this.patch({
      loadingMore: false,
      items: [...this.stateSubject.value.items, ...items],
      total,
    });
  }

  setError(errorMessage: string): void {
    this.patch({ loading: false, loadingMore: false, errorMessage });
  }

  setDateRange(dateRange: DateRange): void {
    this.patch({ dateRange });
  }

  setSendingEmail(sendingEmail: boolean): void {
    this.patch({ sendingEmail });
  }

  setDownloadingCsvFor(downloadingCsvFor: string | null): void {
    this.patch({ downloadingCsvFor });
  }

  private patch(partial: Partial<ShippingAccountingStoreState>): void {
    this.stateSubject.next({ ...this.stateSubject.value, ...partial });
  }
}
